import { useMemo, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { themeQuartz } from 'ag-grid-community';
import Select from 'react-select';
import NiceModal from "@ebay/nice-modal-react";
import AnalyticsCriteriaProfil from '../ModalAnalytics/AnalyticsCriteriaProfil/AnalyticsCriteriaProfil';
import BarChart from '../BarChart/BarChart';
import { buildCriteriaKey } from '/src/utils/criteriaKey';

import "./AnalyticsArray.css";
function AnalyticsArray({ criteriaRows = [], isLoading = false, criteriaIds = [], criteriaResults = [] }) {

    const rowData = criteriaRows;
    const [selectedCategories, setSelectedCategories] = useState([]);

    const onRowClicked = (event) => {
        NiceModal.show(AnalyticsCriteriaProfil, {
            item: event.data,
            criteriaResults
        });
    };

    const categoryOptions = useMemo(() => {
        const categories = [...new Set(rowData.map(item => item.category || "Other"))];
        return categories.map(category => ({ value: category, label: category }));
    }, [rowData]);

    const columnDefs = [
        {
            headerName: "Criteria",
            field: "name",
            cellClass: "ag-cell-ellipsis",
            tooltipValueGetter: (params) => `${params.data.name} - ${params.data.description}`, // tooltip complet
            flex: 2,
            cellRenderer: (params) => (
                <div >
                    <div style={{ fontWeight: "bold" }}>{params.data.name}</div>
                    <div style={{ fontSize: "12px", opacity: 0.7 }}>
                        {params.data.description}
                    </div>
                </div>
            )
        },
        { headerName: "Category", field: "category", flex: 1 },
        { headerName: "Pass Rate", field: "passRate", sortable: true, valueFormatter: (params) => `${params.value}%` },
        { headerName: "Failed", field: "failed", cellRenderer: (params) => <span><span>{params.data.failed}</span><span style={{ color: "var(--gray)" }}>/{params.data.total}</span></span> },
        {
            headerName: "Agent Breakdown",
            field: "chart",
            cellRenderer: (params) => (
                <div style={{ height: "100%", overflow: "hidden", display: "flex", alignItems: "center" }}>
                    <BarChart data={params.data.agentBreakdown} height={140} />
                </div>
            ),
            flex: 2,
        }
    ];

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 120,   // largeur minimale
        flex: 1,         // toutes les colonnes prennent de la place proportionnelle
        cellStyle: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        }
    };

    const criteriaIdSet = new Set(criteriaIds.map(String));
    const selectedCategorySet = new Set(selectedCategories);
    const filteredData = rowData.filter(item =>
        (criteriaIdSet.size === 0 || criteriaIdSet.has(buildCriteriaKey(item.category, item.id))) &&
        (selectedCategorySet.size === 0 || selectedCategorySet.has(item.category || "Other"))
    );

    return (
        <>
            <Select
                classNamePrefix="criteria-select"
                isMulti
                options={categoryOptions}
                value={categoryOptions.filter(opt => selectedCategories.includes(opt.value))}
                onChange={(selected) => setSelectedCategories(selected ? selected.map(s => s.value) : [])}
                hideSelectedOptions={false}
                controlShouldRenderValue={false}
                closeMenuOnSelect={false}
                menuPortalTarget={document.body}
                placeholder={
                    selectedCategories.length
                        ? `${selectedCategories.length} scorecard${selectedCategories.length > 1 ? "s" : ""} selected`
                        : "Filter by scorecard..."
                }
                styles={{
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? "var(--secondary)" : base.backgroundColor,
                        color: state.isSelected ? "var(--main)" : base.color
                    }),
                    container: (base) => ({ ...base, width: "430px", marginBottom: "10px" }),
                    menu: (base) => ({ ...base, marginTop: -10 }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
            />

            <br></br>
            <div className="ag-theme-alpine" style={{ height: 500 }}>
                <AgGridReact
                    rowData={filteredData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={50}
                    onRowClicked={onRowClicked}
                    theme={themeQuartz}
                    rowHeight={150}
                    loading={isLoading}
                    overlayNoRowsTemplate={isLoading ? "Loading..." : "No criteria found"}
                />
            </div>
            <br></br>
            <br></br>
        </>
    );
}

export default AnalyticsArray;
